var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgText({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    clipPath: "url(#clip0_6004_30167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8725 8.66677V20.9914C28.8725 25.5004 26.0317 28.7319 21.4927 28.7319H8.49172C3.9827 28.7319 1.12695 25.5304 1.12695 20.9914V8.74181C1.12695 4.2328 3.96767 1.0013 8.49172 1.0013H21.4927C26.0317 0.926145 28.8725 4.1277 28.8725 8.66677Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.714 16.55H8.506L7.428 19H5.986L10.424 9.2H11.81L16.262 19H14.792L13.714 16.55ZM13.224 15.43L11.11 10.628L8.996 15.43H13.224ZM20.2299 11.51C21.2566 11.51 22.0406 11.762 22.5819 12.266C23.1326 12.77 23.4079 13.5213 23.4079 14.52V19H22.1339V18.02C21.9099 18.3653 21.5879 18.6313 21.1679 18.818C20.7572 18.9953 20.2672 19.084 19.6979 19.084C18.8672 19.084 18.1999 18.8833 17.6959 18.482C17.2012 18.0807 16.9539 17.5533 16.9539 16.9C16.9539 16.2467 17.1919 15.724 17.6679 15.332C18.1439 14.9307 18.8999 14.73 19.9359 14.73H22.0639V14.464C22.0639 13.8853 21.8959 13.442 21.5599 13.134C21.2239 12.826 20.7292 12.672 20.0759 12.672C19.6372 12.672 19.2079 12.7467 18.7879 12.896C18.3679 13.036 18.0132 13.2273 17.7239 13.47L17.1639 12.462C17.5466 12.154 18.0039 11.9207 18.5359 11.762C19.0679 11.594 19.6326 11.51 20.2299 11.51ZM19.9219 18.048C20.4352 18.048 20.8786 17.936 21.2519 17.712C21.6252 17.4787 21.8959 17.152 22.0639 16.732V15.696H19.9919C18.8532 15.696 18.2839 16.0787 18.2839 16.844C18.2839 17.2173 18.4286 17.5113 18.7179 17.726C19.0072 17.9407 19.4086 18.048 19.9219 18.048Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6004_30167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 29.985,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.23c35c32df59b03eb0a70a19d7540ac8.svg";
export { ForwardRef as ReactComponent };